/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import Button from 'gatsby-core-theme/src/components/atoms/button/button';
import styles from './not-found.module.scss';

const NotFound = () => {

  return (
    <div className={styles?.wrapper || ''}>
      <h2>404</h2>

      <span>
        {useTranslate(
          'main_404_title',
          `Oops! We can't seem to find that page anymore.`
        )}
      </span>

      <p>
        {useTranslate(
          'second_404_title',
          `While you're here though, why not check out these top South African Casinos:`
        )}
      </p>
      <div className={styles?.buttonsContainer || ''}>
        <Button
          to="/"
          btnText={useTranslate('firstButton', `Home`)}
          icon={<FaArrowRight title="Right-pointing Arrow Icon" />}
        />
        <Button
          to="/casino-listings"
          btnText={useTranslate('secondButton', `Casinos`)}
          buttonType="secondary"
          gtmClass="404-gtm "
          icon={<FaArrowRight title="Right-pointing Arrow Icon" />}
        />
        <Button
          to="/free-casinos-no-deposit-south-africa "
          btnText={useTranslate('thirdButton', 'No Deposit Bonuses')}
          buttonType="secondary"
          gtmClass="404-gtm "
          icon={<FaArrowRight title="Right-pointing Arrow Icon" />}
        />
      </div>
    </div>
  );
};

export default NotFound;
